const productSubscribe = function () {
  const selectors = {
    wrapper: '[js-product-subscribe="wrapper"]',
    media: '[js-product-subscribe="media"]',
    productSelect: '[js-product-subscribe="product-select"]',
    form: '[js-product-subscribe="form"]',
    sellingPlanInput: '[js-product-subscribe="selling-plan-input"]',
    sellingPlanSelect: '[js-product-subscribe="selling-plan-select"]',
  };

  const wrapper = [...document.querySelectorAll(selectors.wrapper)];

  if (!wrapper.length) {
    return;
  }

  wrapper.forEach(wrapper => {
    const elements = {
      media: wrapper.querySelector(selectors.media),
      productSelect: wrapper.querySelector(selectors.productSelect),
      forms: [...wrapper.querySelectorAll(selectors.form)],
      sellingPlanInputs: [...wrapper.querySelectorAll(selectors.sellingPlanInput)],
      sellingPlanSelects: [...wrapper.querySelectorAll(selectors.sellingPlanSelect)],
    }

    elements.productSelect?.addEventListener('change', handleProductChange)
    elements.sellingPlanSelects?.forEach( select => select.addEventListener('change', handleSellingPlanChange))

    function handleSellingPlanChange(e) {
      const sellingPlanId = e.target.value;
      const formInput = e.target.closest('form').querySelector(selectors.sellingPlanInput);
      formInput.value = sellingPlanId;
    }

    /**
     * Handle product change
     * @param {Event Object} e
     * @returns
     */
    function handleProductChange(e) {
      const productId = elements.productSelect?.value;
      const productImage = elements.productSelect?.querySelector('option:checked').dataset.image

      const form = elements.forms?.filter(form => {
        return form.dataset.productId == productId
      })[0]

      if (!form) {
        return;
      }

      elements.forms?.map(form => form.classList.remove('active'))
      form.classList.add('active');

      if (productImage) {
        swapImage(productImage)
      }
    }

    /**
     * Swap image urls.
     * @param {String} imageUrl
     * @returns
     */
    function swapImage(imageUrl) {
      if (!imageUrl) {
        return;
      }

      const img = elements.media?.querySelector('img:not(.active)')

      if (img) {
        img.setAttribute('src', imageUrl)
        img.addEventListener('load', handleImageSwitch)
      }
    }

    /**
     * Switch images
     * @param {Event Object} e
     */
    function handleImageSwitch(e) {
      elements.media?.querySelector('img.active').classList.remove('active');
      e.target.classList.add('active');
    }
  })
}

productSubscribe();
